const REVERSE_PREFIX = '-';
export const DEFAULT_SORT = '-createdAt';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any */
const createSortBy = (sortByKey: string) => (a: any, b: any): number => {
  /* eslint-enable @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any */
  if (!sortByKey) {
    return 0;
  }

  const reverse = sortByKey.charAt(0) === REVERSE_PREFIX;
  const direction = reverse ? -1 : 1;
  const objectPropertyKey = reverse ? sortByKey.slice(REVERSE_PREFIX.length) : sortByKey;

  if (a[objectPropertyKey] < b[objectPropertyKey]) {
    return -1 * direction;
  }
  if (a[objectPropertyKey] > b[objectPropertyKey]) {
    return 1 * direction;
  }

  return 0;
};

export default createSortBy;
